export default __webpack_public_path__ + "static/media/station_marker.f0d7e5c4.svg";